module.exports = __webpack_public_path__ + "img/person-2.f373344d.png";